// extracted by mini-css-extract-plugin
export default {"deleteWrap":"UserGroupDetail_deleteWrap__iEzCm","buttons":"UserGroupDetail_buttons__HcP9Q","break":"UserGroupDetail_break__CEFu4"};